export default [
    {
        routeName: 'offerFlow-steps-twocol-activity-selection',
        name: 'offerFlow.pages.stepActivitySelection.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-date',
        name: 'offerFlow.pages.stepDate.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-activity-options',
        name: 'offerFlow.pages.stepActivityOptions.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-passengers',
        name: 'offerFlow.pages.stepPassengers.name.common',
        skipIfUpsell: true,
    },
] as ProductFlowStep[];
